import classNames from "classnames";
import ProductItemPrice from "entities/product-item-price";
import { useMemo } from "react";
import { Product } from "shared/api/middleware-api-client";
import OptionConfigurationImage from "shared/ui/option-configuration-image";
import Heading from "shared/ui/typography/Heading";
import { concatClassnames } from "shared/utils/concatClassnames";
import ZakelijkDoorProductItemConfigTable from "./ZakelijkDoorProductItemConfigTable";

interface ProductItemCheckoutProps {
  product: Product;
  controls: JSX.Element;
}

const ZakelijkDoorProductItem = ({
  product,
  controls,
}: ProductItemCheckoutProps) => {
  const imageId = useMemo(() => {
    return product.doorType.imageId;
  }, [product]);

  const doorName = product.doorType.name;

  return (
    <>
      <div
        className={concatClassnames(
          "gg-px-4 sm:gg-px-14 md:gg-px-32 lg:gg-px-0",
          "gg-col-span-12 lg:gg-col-span-8 xl:gg-col-span-7",
          "gg-flex",
          "gg-mb-6 md:gg-mb-10 lg:gg-mb-0",
        )}
      >
        <div
          className={concatClassnames(
            "gg-h-24 gg-w-24 gg-shrink-0 sm:gg-h-32 sm:gg-w-32 lg:gg-h-40 lg:gg-w-40",
            "gg-mr-7",
          )}
        >
          <OptionConfigurationImage
            imageId={imageId}
            className="gg-mt-0.5 gg-h-24 gg-w-24 gg-shrink-0 gg-bg-gray-100 gg-object-cover gg-object-center sm:gg-h-32 sm:gg-w-32 lg:gg-h-40 lg:gg-w-40"
          />
        </div>
        <div className={concatClassnames("gg-grid gg-w-full")}>
          <Heading headingLevel="h2" className="">
            {doorName}
          </Heading>

          <ZakelijkDoorProductItemConfigTable product={product} />
        </div>
      </div>

      <div
        className={concatClassnames(
          "gg-order-2 gg-col-span-12 lg:gg-order-1 lg:gg-col-span-3",
          "gg-border-t gg-py-3.5 lg:gg-border-0 lg:gg-py-0",
          "gg-self-center",
        )}
      >
        <div className="gg-px-4 lg:gg-px-0">{controls}</div>
      </div>

      <ProductItemPrice
        className={classNames(
          "gg-order-1 gg-col-span-5 gg-col-start-4 gg-mb-6 gg-ml-[2px] gg-w-64 sm:gg-col-start-5 sm:gg-w-56 md:gg-col-start-7 md:gg-mb-10 lg:gg-order-2 lg:gg-col-span-1 lg:gg-mb-0 lg:gg-mt-[1.35rem] lg:gg-w-28 xl:gg-col-span-1 xl:gg-col-start-11 xl:gg-w-56",
        )}
        product={product}
      />
    </>
  );
};
export default ZakelijkDoorProductItem;
